import { Route } from '@angular/router';
import { LoginGuard, PermissionGuard } from '@simac/ui';

export const BackendConfigRoute: Route = {
  path: 'backend-config',
  children: [
    {
      path: '',
      loadComponent: () => import('./pages/backendconfig.component').then((m) => m.BackendConfigComponent),
    },
  ],
  canActivate: [LoginGuard, PermissionGuard],
};
